import type { FaireProductEntity } from "../../entity_types/product";

export const p_5d7ezhf9nx: FaireProductEntity = {
  token: "p_5d7ezhf9nx",
  type: "product",
  name: "Mango Matcha - Wholesale",
  brandToken: "b_7piiqmq04r",
  brandName: "Lake & Oak Tea Co.",
  imageUrl: "https://cdn.faire.com/fastly/b653507ce76529a3a173a51dd80754dee38e964ade65cef3fe9d89baa0f46da5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/55bebec2f1616ff1b206442ed3d7902b342c9cdffe84a36827dfebfc7e77766d.jpeg"
  ],
  priceDollars: 90.85,
  description: "Mango Matcha\n\n\nThis one's for the flavour seekers and the sun-drenched dreamers. We've taken our premium Japanese matcha and infused it with the bright, succulent essence of ripe mango for a vibrant fusion that's as fun as it is functional. With a smooth, creamy finish and a hit of tropical sweetness, it's a fruity, energizing escape in every sip. Whisk, chill, and glow.\n\nHow to Enjoy:\n\n * Matcha Latte: Whisk 1 heaping tsp of Mango Matcha with 1 tbsp hot (not boiling) water until tiny bubbles form. Sweeten to taste if desired. Top with 1 cup of hot or cold milk. \n * Delicious served over ice, in oatmeal, baked goods, and smoothies! \n\n\nWhen to Enjoy:\n\n * As a substitute for your morning coffee \n * For a smooth boost of energy \n * When you need to boost your mood \n\n\nModerate caffeine levels\n",
  tags: [],
  msrpDollars: 181.7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:04:43.740Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
